.previewImage {
  padding-top: 2em;
  width: 100%;
}